<template>
    <ies-form-field :field="field">
		<v-row>
				<v-col col="3">
				<label for="accept_range">General Children's Policy: </label>
			</v-col>
			<v-col cols="9">
				<v-radio-group
					id="child-policy"
					v-model="viewValues.accept_range"
					@change="updatePolicy($event)"
					column>
					<v-row><v-radio :value="0"></v-radio><span>Children of all ages are welcome</span></v-row>
					<v-row><v-radio :value="1"></v-radio><span>Only Children aged <input style="border: 1px solid grey; box-sizing: border-box; padding: 4px 6px;" type="number" name="custom_age_range_end" min="0" max="18" v-model="viewValues.custom_age_range_end" @keydown="checkAge"> years and over are accepted</span></v-row>
					<v-row><v-radio :value="2"></v-radio><span>Other <input type="text" style="border: 1px solid grey; box-sizing: border-box; padding: 4px 6px;" name="other_child_acceptance" v-model="viewValues.other_child_acceptance"></span></v-row>
				</v-radio-group>
			</v-col>

			<input type="hidden" :name="this.field.fieldName" :value="field.value">

		</v-row>
	</ies-form-field>
</template>
<style>
#child-policy .row {
	padding-bottom: 4px;
}
</style>



<script>
    /**
     * Allows the the setting of general child policies
	 *
     */
    export default {
        name: 'ies-input-child-policy',
        props: ['field', 'recordData'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                viewValues: {
					'children_policy_key': parseInt(this.recordData.hotel_children_policy_key),
					'accept_range': parseInt(this.recordData.accept_range),
					'custom_age_range_end': 0,
					'other_child_acceptance': '',
				},
            }
        },

		created: function() {
			this.getChildPolicyData();
			this.field.value = this.viewValues;
		},

		methods: {
			getChildPolicyData: function() {
				axios.get("/api/child-policy-data/" + this.recordData.hotel_children_policy_key).then((response) => {
					let policy = response.data.policy;
					console.log(policy);
					this.viewValues.accept_range = policy.accept_range;
					this.viewValues.custom_age_range_end = policy.custom_age_range_end;
					this.viewValues.other_child_acceptance = policy.other_child_acceptance;
				});
			},

			updatePolicy: function(event) {
				let value = event;
				switch(parseInt(value)) {
					case 0:
						this.viewValues.custom_age_range_end = 0;
						this.viewValues.other_child_acceptance = null;
						break;
					case 1:
						this.viewValues.other_child_acceptance = null;
						break;
					case 2:
						this.viewValues.custom_age_range_end = 0;
						break;
				}
			},

			checkAge: function(e) {
				let key = e.key;
				let value = e.target.value;
				let new_value = Number(value + key);
                let max = Number(event.target.max);
                if(new_value > max){ event.preventDefault(); }
			}
		},

        watch: {
			'viewValues.accept_range': function(newValue) {
				this.field.value = this.viewValues;
			},
			'viewValues.custom_age_range_end': function(newValue) {
				this.field.value = this.viewValues;
			},
			'viewValues.other_child_acceptance': function(newValue) {
				this.field.value = this.viewValues;
			},
        }
    }
</script>






